// TODO: Switch logic to call to a backend API
// At the moment its using useImageStore
import { useImageStore } from "./useImageStore";

export const useImageManager = () => {
    return {
        images: useImageStore((s) => s.images),
        addImages: useImageStore((s) => s.addImages),
        removeImage: useImageStore((s) => s.removeImage),
        updateImageMeta: useImageStore((s) => s.updateImageMeta),
        clearImages: useImageStore((s) => s.clearImages),
    };
};